<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t("pageBids.new.title") }}
          <!-- <span v-if="client && client.short_name">для {{ client.short_name }}</span> -->
          <span v-if="inn && client"
            >{{ $t("pageBids.new.forINN") }} {{ inn }}</span
          >
          <span v-if="client">&nbsp;({{ client.short_name }})</span>
        </h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <span @click="$router.go(-1)" class="goback">{{
      $t("pageBids.new.navigationBack")
    }}</span>

    <loading v-if="!isLoaded && !clients" />

    <v-layout wrap v-if="clients && !clients.length">
      <v-flex xs12>
        <h2 class="empty_title">
          {{ $t("pageBids.new.beforeLinkAddClient") }}
          <router-link to="/add-client">{{
            $t("pageBids.new.linkAddClient")
          }}</router-link>
        </h2>
      </v-flex>
    </v-layout>

    <v-layout v-if="clients && clients.length" mx-0>
      <v-flex xs12 block bid__create>
        <transition name="slide-fade" mode="in-out">
          <v-layout
            row
            wrap
            bid__create-tender
            v-if="userRole === 30 && !client"
          >
            <v-flex mt-4 xs12>
              <v-layout
                row
                wrap
                justify-center
                v-if="profile && !profile.count_ClientCompany"
              >
                <v-flex md4>
                  <v-alert
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                    style="text-align: left"
                  >
                    {{ $t("pageBids.new.promtCreateText") }}
                    <a href="#" @click.prevent="onCreateNewClient">{{
                      $t("pageBids.new.goto")
                    }}</a>
                  </v-alert>
                </v-flex>
              </v-layout>
              <h2>{{ $t("pageBids.new.selectClient") }}</h2>

              <v-layout row wrap justify-center>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="client"
                    :items="clients"
                    item-text="short_name"
                    return-object
                  >
                    <template v-slot:append-item>
                      <v-btn block @click.stop="onCreateNewClient">{{
                        $t("pageBids.new.createNewCompany")
                      }}</v-btn>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </transition>

        <!-- <transition name="slide-fade" mode="in-out">
                    <v-layout row wrap bid__create-tender v-if="userRole === 30 && client">
                        <v-flex xs12>
                            <v-divider />
                        </v-flex>
                    </v-layout>
                </transition>-->

        <transition name="slide-fade" mode="in-out">
          <v-layout
            row
            wrap
            :class="{ 'bid__type--active': selectedProductType }"
            v-if="userRole !== 30 || client"
          >
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2>
                    {{
                      selectedProductType
                        ? getServiceBySelected().name
                        : $t("pageBids.new.selectProduct")
                    }}
                  </h2>
                </v-flex>
                <v-flex xs12 v-if="selectedProductType">
                  <span @click="setProductType(-1)" class="goback">{{
                    $t("pageBids.new.goBackSelectService")
                  }}</span>
                </v-flex>
              </v-layout>

              <v-layout
                row
                wrap
                pb-4
                align-center
                justify-center
                v-if="!selectedProductType"
                class="noselect"
              >
                <table class="service-list-table">
                  <tbody>
                    <tr
                      v-for="(service, idx) in serviceTypes"
                      :key="`service_${idx}`"
                      @click="setProductType(service.service_type)"
                      :class="{
                        service__item: true,
                        active:
                          selectedProductType ===
                          `service_${service.service_type}`,
                      }"
                    >
                      <td>
                        <div
                          class="service__icon"
                          v-if="service.service_type === 1"
                        >
                          <svg
                            height="512pt"
                            viewBox="0 0 512 512"
                            width="512pt"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m512 182h-241v-92h30v60h30v-120h-30v30h-30v-60h-90v182h-32.507812c-6.96875-34.191406-37.273438-60-73.492188-60-41.355469 0-75 33.644531-75 75v240c0 41.355469 33.644531 75 74.996094 75h376.003906v-60h61zm-286 134.390625c-9.863281-21.371094-15-44.648437-15-68.472656v-97.917969h30v97.917969c0 23.824219-5.136719 47.101562-15 68.472656zm15-196.390625h-30v-30h30zm0-90v30h-30v-30zm-166 122c24.8125 0 45 20.1875 45 45v180.039062c-12.542969-9.4375-28.128906-15.039062-45-15.039062s-32.457031 5.601562-45 15.039062v-180.039062c0-24.8125 20.1875-45 45-45zm346 330h-346.003906c-24.808594 0-44.996094-20.1875-44.996094-45s20.1875-45 45-45 45 20.1875 45 45v15h301zm61-60h-332v-210h31v35.917969c0 36.804687 10.363281 72.488281 30 103.511719v40.570312h30v-40.570312c19.636719-31.023438 30-66.707032 30-103.511719v-35.917969h211zm0 0"
                            />
                            <path d="m301 362h150v30h-150zm0 0" />
                            <path d="m301 302h90v30h-90zm0 0" />
                            <path d="m301 242h150v30h-150zm0 0" />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 2"
                        >
                          <svg
                            height="512pt"
                            viewBox="0 0 512 512"
                            width="512pt"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m390 242h-150v90h150zm-120 30h30v30h-30zm90 30h-30v-30h30zm0 0"
                            />
                            <path d="m60 362h60v30h-60zm0 0" />
                            <path d="m150 362h60v30h-60zm0 0" />
                            <path d="m240 362h60v30h-60zm0 0" />
                            <path d="m330 362h60v30h-60zm0 0" />
                            <path d="m60 422h330v30h-330zm0 0" />
                            <path
                              d="m512 0h-450v182h-62v330h450v-182h62zm-30 30v30h-390v-30zm0 60v30h-390v-30zm-62 392h-390v-270h390zm30-182v-118h-358v-32h390v150zm0 0"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 3"
                        >
                          <svg
                            height="512pt"
                            viewBox="0 -48 512 512"
                            width="512pt"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                            />
                            <path
                              d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                            />
                            <path
                              d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                            />
                            <path
                              d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 4"
                        >
                          <svg
                            height="512pt"
                            viewBox="0 -48 512 512"
                            width="512pt"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                            />
                            <path
                              d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                            />
                            <path
                              d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                            />
                            <path
                              d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 5"
                        >
                          <svg
                            height="512pt"
                            viewBox="0 -48 512 512"
                            width="512pt"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                            />
                            <path
                              d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                            />
                            <path
                              d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                            />
                            <path
                              d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 6"
                        >
                          <svg
                            style="width: 768pt; height: 768pt"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H15V19H5V5H7V7H17V5H19V14H21V5A2,2 0 0,0 19,3M12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5M17,16V22L22,19L17,16M17,11H7V9H17V11M15,15H7V13H15V15Z"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 7"
                        >
                          <svg
                            style="width: 768pt; height: 768pt"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M11 8C11 10.21 9.21 12 7 12C4.79 12 3 10.21 3 8C3 5.79 4.79 4 7 4C9.21 4 11 5.79 11 8M11 14.72V20H0V18C0 15.79 3.13 14 7 14C8.5 14 9.87 14.27 11 14.72M24 20H13V3H24V20M16 11.5C16 10.12 17.12 9 18.5 9C19.88 9 21 10.12 21 11.5C21 12.88 19.88 14 18.5 14C17.12 14 16 12.88 16 11.5M22 7C20.9 7 20 6.11 20 5H17C17 6.11 16.11 7 15 7V16C16.11 16 17 16.9 17 18H20C20 16.9 20.9 16 22 16V7Z"
                            />
                          </svg>
                        </div>

                        <div
                          class="service__icon"
                          v-if="service.service_type === 8"
                        >
                          <svg
                            style="width: 768pt; height: 768pt"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="currentColor"
                              d="M12,4H5A3,3 0 0,0 2,7V15A3,3 0 0,0 5,18L4,19V20H5L7,17.97L9,18V13H4V6H13V8H15V7A3,3 0 0,0 12,4M5,14A1,1 0 0,1 6,15A1,1 0 0,1 5,16A1,1 0 0,1 4,15A1,1 0 0,1 5,14M20.57,9.66C20.43,9.26 20.05,9 19.6,9H12.41C11.95,9 11.58,9.26 11.43,9.66L10,13.77V19.28C10,19.66 10.32,20 10.7,20H11.32C11.7,20 12,19.62 12,19.24V18H20V19.24C20,19.62 20.31,20 20.69,20H21.3C21.68,20 22,19.66 22,19.28V17.91L22,13.77L20.57,9.66M12.41,10H19.6L20.63,13H11.38L12.41,10M12,16A1,1 0 0,1 11,15A1,1 0 0,1 12,14A1,1 0 0,1 13,15A1,1 0 0,1 12,16M20,16A1,1 0 0,1 19,15A1,1 0 0,1 20,14A1,1 0 0,1 21,15A1,1 0 0,1 20,16Z"
                            />
                          </svg>
                        </div>
                      </td>
                      <td>
                        <h2 class="left">{{ service.name }}</h2>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-layout>

              <!-- <v-layout row wrap pb-4 align-center justify-center>
                <v-flex
                  v-for="(service, idx) in serviceTypes"
                  :key="`service_${idx}`"
                  @click="setProductType(service.service_type)"
                  :class="{
                    service__item: true,
                    active:
                      selectedProductType === `service_${service.service_type}`,
                  }"
                  shrink
                >
                  <div class="service__icon" v-if="service.service_type === 1">
                    <svg
                      height="512pt"
                      viewBox="0 0 512 512"
                      width="512pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m512 182h-241v-92h30v60h30v-120h-30v30h-30v-60h-90v182h-32.507812c-6.96875-34.191406-37.273438-60-73.492188-60-41.355469 0-75 33.644531-75 75v240c0 41.355469 33.644531 75 74.996094 75h376.003906v-60h61zm-286 134.390625c-9.863281-21.371094-15-44.648437-15-68.472656v-97.917969h30v97.917969c0 23.824219-5.136719 47.101562-15 68.472656zm15-196.390625h-30v-30h30zm0-90v30h-30v-30zm-166 122c24.8125 0 45 20.1875 45 45v180.039062c-12.542969-9.4375-28.128906-15.039062-45-15.039062s-32.457031 5.601562-45 15.039062v-180.039062c0-24.8125 20.1875-45 45-45zm346 330h-346.003906c-24.808594 0-44.996094-20.1875-44.996094-45s20.1875-45 45-45 45 20.1875 45 45v15h301zm61-60h-332v-210h31v35.917969c0 36.804687 10.363281 72.488281 30 103.511719v40.570312h30v-40.570312c19.636719-31.023438 30-66.707032 30-103.511719v-35.917969h211zm0 0"
                      />
                      <path d="m301 362h150v30h-150zm0 0" />
                      <path d="m301 302h90v30h-90zm0 0" />
                      <path d="m301 242h150v30h-150zm0 0" />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 2">
                    <svg
                      height="512pt"
                      viewBox="0 0 512 512"
                      width="512pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m390 242h-150v90h150zm-120 30h30v30h-30zm90 30h-30v-30h30zm0 0"
                      />
                      <path d="m60 362h60v30h-60zm0 0" />
                      <path d="m150 362h60v30h-60zm0 0" />
                      <path d="m240 362h60v30h-60zm0 0" />
                      <path d="m330 362h60v30h-60zm0 0" />
                      <path d="m60 422h330v30h-330zm0 0" />
                      <path
                        d="m512 0h-450v182h-62v330h450v-182h62zm-30 30v30h-390v-30zm0 60v30h-390v-30zm-62 392h-390v-270h390zm30-182v-118h-358v-32h390v150zm0 0"
                      />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 3">
                    <svg
                      height="512pt"
                      viewBox="0 -48 512 512"
                      width="512pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                      />
                      <path
                        d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                      />
                      <path
                        d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                      />
                      <path
                        d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                      />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 4">
                    <svg
                      height="512pt"
                      viewBox="0 -48 512 512"
                      width="512pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                      />
                      <path
                        d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                      />
                      <path
                        d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                      />
                      <path
                        d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                      />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 5">
                    <svg
                      height="512pt"
                      viewBox="0 -48 512 512"
                      width="512pt"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m497 0h-482c-8.285156 0-15 6.714844-15 15v385.601562c0 8.28125 6.714844 15 15 15h482c8.285156 0 15-6.71875 15-15v-385.601562c0-8.285156-6.714844-15-15-15zm-467 287.066406h452v34.269532h-452zm452-30h-168.085938c41.253907-21.128906 69.554688-64.085937 69.554688-113.53125 0-49.445312-28.300781-92.40625-69.554688-113.535156h168.085938zm-226-16.066406c-53.742188 0-97.46875-43.722656-97.46875-97.46875 0-53.742188 43.726562-97.464844 97.46875-97.464844s97.46875 43.722656 97.46875 97.46875c0 53.742188-43.726562 97.464844-97.46875 97.464844zm-226-211h168.085938c-41.253907 21.128906-69.554688 64.089844-69.554688 113.53125 0 49.445312 28.300781 92.40625 69.554688 113.535156h-168.085938zm452 355.601562h-452v-34.269531h452zm0 0"
                      />
                      <path
                        d="m79.265625 64.265625c-8.28125 0-15 6.71875-15 15v128.535156c0 8.285157 6.71875 15 15 15 8.285156 0 15-6.714843 15-15v-128.535156c0-8.28125-6.714844-15-15-15zm0 0"
                      />
                      <path
                        d="m432.734375 222.800781c8.28125 0 15-6.714843 15-15v-128.535156c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v128.535156c0 8.285157 6.714844 15 15 15zm0 0"
                      />
                      <path
                        d="m283.992188 140.761719-42.308594-21.152344c-1.738282-.871094-2.816406-2.617187-2.816406-4.578125 0-2.589844 2.105468-4.699219 4.699218-4.699219h36.535156c8.28125 0 15-6.714843 15-15 0-8.28125-6.71875-15-15-15h-9.101562v-1.066406c0-8.28125-6.714844-15-15-15s-15 6.71875-15 15v1.171875c-17.9375 1.320312-32.132812 16.324219-32.132812 34.609375 0 13.382813 7.433593 25.410156 19.402343 31.394531l42.300781 21.152344c1.582032.792969 2.5625 2.375 2.5625 4.152344 0 2.386718-1.894531 4.988281-4.988281 4.988281h-36.246093c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h9.101562v1.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-1.191406c18.425781-1.480469 32.132812-16.972656 32.132812-34.878906 0-13.199219-7.335937-25.0625-19.140624-30.96875zm0 0"
                      />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 6">
                    <svg
                      style="width: 768pt; height: 768pt"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H15V19H5V5H7V7H17V5H19V14H21V5A2,2 0 0,0 19,3M12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5M17,16V22L22,19L17,16M17,11H7V9H17V11M15,15H7V13H15V15Z"
                      />
                    </svg>
                  </div>

                  <div class="service__icon" v-if="service.service_type === 7">
                    <svg
                      style="width: 768pt; height: 768pt"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M11 8C11 10.21 9.21 12 7 12C4.79 12 3 10.21 3 8C3 5.79 4.79 4 7 4C9.21 4 11 5.79 11 8M11 14.72V20H0V18C0 15.79 3.13 14 7 14C8.5 14 9.87 14.27 11 14.72M24 20H13V3H24V20M16 11.5C16 10.12 17.12 9 18.5 9C19.88 9 21 10.12 21 11.5C21 12.88 19.88 14 18.5 14C17.12 14 16 12.88 16 11.5M22 7C20.9 7 20 6.11 20 5H17C17 6.11 16.11 7 15 7V16C16.11 16 17 16.9 17 18H20C20 16.9 20.9 16 22 16V7Z"
                      />
                    </svg>
                  </div>

                  <h2>{{ service.name }}</h2>
                </v-flex>
              </v-layout> -->
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="in-out">
          <v-layout
            row
            wrap
            bid__create-tender
            v-if="selectedProductType && (bid.type === 3 || bid.type === 4)"
          >
            <v-flex mt-4 xs12>
              <v-btn
                color="primary"
                @click="createBid"
                class="mt-4"
                :disabled="!isNewTenderValid"
                >{{$t("pageBids.new.createNewBidAction")}}</v-btn
              >
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="in-out">
          <v-layout
            row
            wrap
            bid__create-tender
            v-if="selectedProductType && (bid.type !== 3 || bid.type !== 4)"
          >
            <v-flex xs12>
              <v-divider />
            </v-flex>
            <v-flex mt-4 xs12 v-if="isShowSearch || isCommercial">
              <h2 class="mb-4">{{$t("pageBids.new.infoProcedure")}}</h2>

              <v-layout row wrap justify-center>
                <v-flex shrink bid__create-tender-number pr-0>
                  <v-text-field
                    :disabled="isCommercial"
                    v-model="bid[bidServiceType].tender_number"
                    :label="
                      bidServiceType === 'bankKik' && isContractKikNumber
                        ? $t('pageBids.new.pleaseInputNumberContract')
                        : $t('pageBids.new.pleaseInputNumberPurch')
                    "
                    class="mt-0 pt-0"
                    @keyup.enter="getTender"
                  ></v-text-field>
                </v-flex>
                <v-flex shrink pl-0>
                  <v-btn
                    color="primary"
                    :disabled="isCommercial"
                    @click="getTender"
                    tеext
                    iicon
                    class="ml-2"
                    >{{$t('pageBids.new.actionFind')}}
                    <!-- <v-icon>search</v-icon> -->
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                justify-center
                v-if="bidServiceType === 'bankKik'"
              >
                <v-flex shrink bid__create-tender-number pr-0>
                  <div>
                    <v-checkbox
                      v-model="isContractKikNumber"
                      :label="$t('pageBids.new.contractKikNumber')"
                      color="secondary"
                      hide-details
                      class="mt-0"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout
            row
            wrap
            justify-center
            mb-4
            v-if="
              selectedProductType === 'service_1' &&
                (isNewTenderAllow || isCommercial)
            "
          >
            <v-checkbox
              v-model="isCommercial"
              :label="$t('pageBids.new.contractNumber')"
              color="secondary"
              hide-details
              class="mt-0"
            ></v-checkbox>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="in-out">
          <v-layout row wrap v-if="selectedProductType && !isCommercial">
            <v-flex xs12 v-if="!isShowSearch">
              <h1>{{$t('pageBids.new.newBid')}}</h1>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout row wrap v-if="errors">
            <v-flex xs12>
              <h2>
                <v-icon color="error">error</v-icon>
                {{ errors }}
              </h2>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout row wrap v-if="isNewTenderAllow">
            <v-flex xs12>
              <span @click="newTenderCreate" class="bid__create-blank"
                >{{$t('pageBids.new.newCustom')}}</span
              >
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout
            row
            wrap
            bid__tender-content
            vv-if="isNewTenderAllow || isNewTenderCreate"
            v-if="isNewTenderCreate"
          >
            <v-flex xs12 text-left px-5 py-5>
              <v-form ref="form" lazy-validation v-model="validForm">
                <!-- <v-layout row wrap>
                <v-flex xs12>
                  <v-expansion-panels flat>
                    <v-expansion-panel v-model="isOpenGetCompanyByInnOgrn">
                      <v-expansion-panel-header class="grey lighten-4">
                        <h3>Заполнить данные заказчика по ИНН/ОГРН</h3>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout row wrap mt-2>
                          <v-flex grow>
                            <v-text-field
                              v-model="innOgrn"
                              placeholder="Поиск по ИНН/ОГРН"
                              hint="Введите ИНН или ОГРН для автоматического заполнения"
                              @keyup.enter="getCompanyByInnOgrn"
                              class="mt-0 pt-0"
                              persistent-hint
                            ></v-text-field>
                          </v-flex>
                          <v-flex shrink>
                            <v-btn
                              @click="getCompanyByInnOgrn"
                              :loading="isGetCompanyByInnOgrn"
                              :disabled="!innOgrn"
                              color="primary"
                              outlined
                              >Заполнить</v-btn
                            >
                          </v-flex>
                          <v-flex xs12>
                            <h4 class="error--text">
                              {{ getCompanyByInnOgrnMessage }}
                            </h4>
                          </v-flex>
                        </v-layout>
                        <v-divider />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout> -->

                <v-layout row wrap v-if="bid.type === 8">
                  <v-flex xs12>
                    <v-select
                      v-model="bid[bidServiceType].tender_subject"
                      :items="[
                        $t('leasingType.0'),
                        $t('leasingType.1'),
                        $t('leasingType.2'),
                        $t('leasingType.3'),
                        $t('leasingType.4'),
                        $t('leasingType.5'),
                        $t('leasingType.6'),
                        $t('leasingType.7'),
                      ]"
                      :rules="rules.rule"
                      :label="$t('pageBids.new.leasingTypeField')"
                      disabled2
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  v-if="
                    !isCommercial &&
                      isNewTenderCreate &&
                      bid.type !== 7 &&
                      bid.type !== 8
                  "
                >
                  <v-flex xs6>
                    <v-select
                      v-model="bid[bidServiceType].federal_law"
                      :items="[44, 223, 615]"
                      :rules="rules.rule"
                      disabled
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      v-model="bid[bidServiceType].placement_method"
                      :items="[$t('pageBids.new.placementMethod')]"
                      :rules="rules.rule"
                      disabled
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-show="bid.type !== 7">
                  <v-flex xs12>
                    <!-- <v-text-field
                    v-model="bid[bidServiceType].customer"
                    label="Заказчик"
                    :rules="rules.rule"
                    required
                  ></v-text-field> -->
                    <company-search
                      v-if="isShowCompanySearch"
                      :title="nameClientField"
                      :dadata="setDaDataForm"
                      required
                      :onChangeCallback="onChangeCallbackCompanySearch"
                    ></company-search>
                  </v-flex>
                </v-layout>

                <!-- <v-layout row wrap v-if="bid[bidServiceType].fz === 44">
                                <v-text-field
                                    v-model="bid[bidServiceType].lots"
                                    label="Количество лотов"
                                    :rules="rules.rule"
                                    required
                                ></v-text-field>
                            </v-layout>-->

                <!-- <v-layout row wrap v-if="bid[bidServiceType].fz === 223">
                                <v-text-field
                                    v-model="bid[bidServiceType].lots"
                                    label="Лоты"
                                    :rules="rules.rule"
                                    required
                                ></v-text-field>
                            </v-layout>-->
                <!-- <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="bid[bidServiceType].customer_inn"
                    label="ИНН заказчика"
                    :rules="rules.inn"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout> -->

                <v-layout
                  row
                  wrap
                  v-if="isNewTenderCreate"
                  v-show="bid.type !== 7"
                >
                  <v-flex xs12>
                    <v-text-field
                      v-model="bid[bidServiceType].customer_address"
                      :label="nameClientAddressField"
                      :rules="rules.rule"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-if="isNewTenderCreate && bid.type !== 8">
                  <v-flex xs12>
                    <v-text-field
                      v-model="bid[bidServiceType].tender_subject"
                      :label="
                        bid.type === 7
                          ? $t('pageBids.new.tenderSubjectType7')
                          : $t('pageBids.new.tenderSubject')
                      "
                      :rules="rules.rule"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  v-if="
                    bid.type === 7 &&
                      isNewTenderCreate &&
                      bid[bidServiceType].federal_law === 44
                  "
                >
                  <v-flex xs12>
                    <v-text-field
                      v-model="bid[bidServiceType].credit_sum"
                      :label="$t('pageBids.new.creditSum')"
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].credit_sum = bid[
                          bidServiceType
                        ].security_sum = bid[
                          bidServiceType
                        ].initial_contract_sum = Number(
                          bid[bidServiceType].credit_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="
                    bid.type === 7 &&
                      isNewTenderCreate &&
                      bid[bidServiceType].federal_law === 44
                  "
                >
                  <v-flex xs6>
                    <calendar
                      required
                      v-model="bid[bidServiceType].credit_date_from"
                      :label="$t('pageBids.new.dateFrom')"
                    ></calendar>
                  </v-flex>
                  <v-flex xs6>
                    <calendar
                      required
                      v-model="bid[bidServiceType].credit_date_to"
                      :label="$t('pageBids.new.dateTo')"
                    ></calendar>
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  v-if="
                    bid.type !== 7 &&
                      isNewTenderCreate &&
                      bid[bidServiceType].federal_law === 44
                  "
                >
                  <v-flex xs6>
                    <v-text-field
                      v-model="bid[bidServiceType].initial_contract_sum"
                      :label="$t('pageBids.new.initialContractSum')"
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].initial_contract_sum = Number(
                          bid[bidServiceType].initial_contract_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 vv-if="bid.type !== 6">
                    <v-text-field
                      v-model="bid[bidServiceType].security_sum"
                      :label="
                        bid.type === 6
                          ? $t('pageBids.new.securitySumBid')
                          : $t('pageBids.new.securitySumContract')
                      "
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].security_sum = Number(
                          bid[bidServiceType].security_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  v-if="
                    isNewTenderCreate && selectedProductType && bid.type === 8
                  "
                >
                  <v-flex xs6>
                    <v-text-field
                      v-model="bid[bidServiceType].credit_sum"
                      :label="$t('pageBids.new.creditSumLeasing')"
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].credit_sum = bid[
                          bidServiceType
                        ].actual_contract_sum = bid[
                          bidServiceType
                        ].initial_contract_sum = Number(
                          bid[bidServiceType].credit_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field
                      v-model="bid[bidServiceType].security_sum"
                      :label="$t('pageBids.new.initialFee')"
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].security_sum = Number(
                          bid[bidServiceType].security_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <calendar
                      required
                      v-model="bid[bidServiceType].date_from"
                      :label="$t('pageBids.new.dateFrom')"
                    ></calendar>
                  </v-flex>
                  <v-flex xs6>
                    <calendar
                      required
                      v-model="bid[bidServiceType].date_to"
                      :label="$t('pageBids.new.dateTo')"
                    ></calendar>
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  v-if="
                    isNewTenderCreate && selectedProductType && bid.type === 5
                  "
                >
                  <v-flex xs4>
                    <v-text-field
                      v-model="bid[bidServiceType].credit_sum"
                      :label="$t('pageBids.new.creditSumCredit')"
                      :rules="rules.rule"
                      type="number"
                      v-on:blur="
                        bid[bidServiceType].credit_sum = Number(
                          bid[bidServiceType].credit_sum
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs4>
                    <v-menu
                      ref="credit_date_from"
                      v-model="creditDateFrom"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="credit_date_from"
                          :label="$t('pageBids.new.creditDateFrom')"
                          prepend-icon="event"
                          v-on="on"
                          v-on:blur="formatCreditDateFrom"
                          v-mask="'##.##.####'"
                          return-masked-value
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="bid[bidServiceType].credit_date_from"
                        mmax="bid[bidServiceType].credit_date_to"
                        :max="maxCreaditDateFrom"
                        :min="new Date().toISOString().substr(0, 10)"
                        @change="saveCreditDateFrom"
                        llocale="ru-ru"
                        first-day-of-week="1"
                        no-title
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs4>
                    <v-menu
                      ref="credit_date_to"
                      v-model="creditDateTo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="credit_date_to"
                          :label="$t('pageBids.new.creditDateTo')"
                          prepend-icon="event"
                          v-on="on"
                          v-on:blur="formatCreditDateTo"
                          v-mask="'##.##.####'"
                          return-masked-value
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="bid[bidServiceType].credit_date_to"
                        mmin="bid[bidServiceType].credit_date_from"
                        :min="minCreaditDateTo"
                        :max="maxCreaditDateTo"
                        @change="saveCreditDateTo"
                        llocale="ru-ru"
                        first-day-of-week="1"
                        no-title
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </transition>

        <loading
          v-if="isProcess && !isLoaded && !tender"
          :text="$t('pageBids.new.processLoadingTender')"
        />

        <transition name="slide-fade" mode="out-in">
          <v-layout
            row
            wrap
            bid__tender-content
            v-if="
              bid.type !== 7 &&
                bid.type !== 8 &&
                !isProcess &&
                tender &&
                isLoaded &&
                isNewTenderCreate &&
                !isCommercial
            "
          >
            <v-flex xs12 text-left pa-5 ma-3>
              <v-layout row wrap>
                <v-flex xs4 bid__tender-title> {{$t('pageBids.new.nameClient.default')}} </v-flex>
                <v-flex xs8 bid__tender-text>{{ tender.customer }}</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4 bid__tender-title> {{$t('pageBids.new.fz')}} </v-flex>
                <v-flex xs8 bid__tender-text>{{ tender.fz }}</v-flex>
              </v-layout>

              <v-layout row wrap v-if="tender.fz === 44">
                <v-flex xs4 bid__tender-title
                  > {{$t('pageBids.new.initialContractSum')}} </v-flex
                >
                <v-flex xs8 bid__tender-text>{{
                  tender.initial_max_cost | formatPrice
                }}</v-flex>
              </v-layout>

              <v-layout
                row
                wrap
                v-if="
                  tender &&
                    tender.fz === 44 &&
                    tender.lots &&
                    tender.lots[0] &&
                    tender.lots[0].num
                "
              >
                <v-flex xs4 bid__tender-title>{{$t('pageBids.new.lots')}}</v-flex>
                <v-flex xs8 bid__tender-text>{{ tender.lots[0].num }}</v-flex>
              </v-layout>

              <v-layout row wrap v-if="tender.fz === 223 && tender.lots">
                <v-flex xs4 bid__tender-title>{{$t('pageBids.new.lots')}}</v-flex>
                <v-flex xs8 bid__tender-text>
                  <div v-for="(lot, idx) in tender.lots" :key="'lot_' + idx">
                    {{ lot.subject }} ({{
                      Number(lot.initial_max_cost).toLocaleString("ru")
                    }})
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs4 bid__tender-title>{{$t('pageBids.new.addressClient.default')}}</v-flex>
                <v-flex xs8 bid__tender-text>{{ tender.region }}</v-flex>
              </v-layout>
              <v-layout row wrap v-if="tender.fz === 44">
                <v-flex xs4 bid__tender-title>{{
                  bid.type === 6
                    ? $t('pageBids.new.amountSecurityType6')
                    : $t('pageBids.new.amountSecurity')
                }}</v-flex>
                <v-flex xs8 bid__tender-text>{{
                  tender.security_amount | formatPrice
                }}</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4 bid__tender-title
                  >{{$t('pageBids.new.subject')}}</v-flex
                >
                <v-flex xs8 bid__tender-text>{{ tender.subject }}</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4 bid__tender-title>{{$t('pageBids.new.deadline')}}</v-flex>
                <v-flex xs8 bid__tender-text>{{
                  tender.issue_deadline_date
                }}</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4 bid__tender-title></v-flex>
                <v-flex xs8 bid__tender-text>
                  <a :href="tender.url" target="_blank"
                    >{{$t('pageBids.new.linkZakupki')}}</a
                  >
                </v-flex>
              </v-layout>

              <!-- <v-layout row wrap v-if="selectedProductType && bid.type === 5">
                                <v-flex xs4>
                                    <v-text-field
                                        v-model="bid[bidServiceType].credit_sum"
                                        label="Сумма кредита"
                                        :rules="rules.rule"
                                        type="number"
                                        v-on:blur="bid[bidServiceType].credit_sum = Number(bid[bidServiceType].credit_sum)"
                                        required
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs4>
                                    <v-menu
                                        ref="credit_date_from"
                                        v-model="creditDateFrom"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="credit_date_from"
                                                label="Срок кредита от"
                                                prepend-icon="event"
                                                v-on="on"
                                                v-on:blur="formatCreditDateFrom"
                                                v-mask="'##.##.####'"
                                                return-masked-value
                                                required
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            ref="picker"
                                            v-model="bid[bidServiceType].credit_date_from"
                                            :max="bid[bidServiceType].credit_date_to"
                                            :min="new Date().toISOString().substr(0, 10)"
                                            @change="saveCreditDateFrom"
                                            locale="ru-ru"
                                            first-day-of-week="1"
                                            no-title
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs4>
                                    <v-menu
                                        ref="credit_date_to"
                                        v-model="creditDateTo"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="credit_date_to"
                                                label="Срок кредита до"
                                                prepend-icon="event"
                                                v-on="on"
                                                v-on:blur="formatCreditDateTo"
                                                v-mask="'##.##.####'"
                                                return-masked-value
                                                required
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            ref="picker"
                                            v-model="bid[bidServiceType].credit_date_to"
                                            :min="bid[bidServiceType].credit_date_from"
                                            @change="saveCreditDateTo"
                                            locale="ru-ru"
                                            first-day-of-week="1"
                                            no-title
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>-->
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout row wrap v-if="createErrors">
            <v-flex xs12 mt-4>
              <h2>
                <v-icon color="error">warning</v-icon>
                {{ createErrors }}
              </h2>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="slide-fade" mode="out-in">
          <v-layout row wrap v-if="validationErrors">
            <v-flex xs12 mt-4>
              <h3
                v-for="(error, idx) in validationErrors"
                :key="`error_${idx}`"
                class="error--text"
              >
                {{ error }}
              </h3>
            </v-flex>
          </v-layout>
        </transition>

        <v-layout
          row
          wrap
          text-center
          v-if="selectedProductType && (tender || isNewTenderAllow)"
        >
          <v-flex xs12>
            <v-btn
              color="primary"
              @click="createBid(true)"
              class="mt-4"
              :disabled="!isNewTenderValid"
              :loading="loadingCreateBid"
              ><!--Создать новую заявку-->{{$t('pageBids.new.createBidAction')}}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import { mapState } from "vuex";
import showNotify from "@/services/noty";
import rules from "@/utils/data/rules";
import BidModel from "@/models/BidModel";
import formatPrice from "@/mixins/filters/formatPrice";
import { mask } from "vue-the-mask";
import CompanySearch from "@/components/lib/CompanySearch";
import moment from "moment";
import Calendar from "@/components/lib/Calendar";

import i18n from "@/services/i18n";

export default {
  name: "AddBid",
  directives: { mask },
  mixins: [formatPrice],
  components: { CompanySearch, Calendar },
  data: () => ({
    valid: false,
    isLoaded: false,
    loadingCreateBid: false,
    isProcess: false,
    errors: null,
    createErrors: null,
    validationErrors: null,
    isNewTenderAllow: false,
    isNewTenderCreate: false,
    isShowSearch: true,
    name: "",
    bid: null,
    tender: null,
    clients: null,
    client: null,
    inn: null,
    selectedProductType: null,
    bidServiceType: "", // "bankGuarantee",
    bidServiceTypeId: null,
    serviceTypes:
      i18n.locale == "ru"
        ? [
            { service_type: 1, name: i18n.t("serviceTypes.1") },
            { service_type: 2, name: i18n.t("serviceTypes.2") },
            //{ service_type: 3, name: i18n.t('serviceTypes.3') },
            //{ service_type: 4, name: i18n.t('serviceTypes.4') },
            { service_type: 5, name: i18n.t("serviceTypes.5") },
            { service_type: 6, name: i18n.t("serviceTypes.6") },
            { service_type: 7, name: i18n.t("serviceTypes.7") },
            { service_type: 8, name: i18n.t("serviceTypes.8") },
          ]
        : [
            { service_type: 1, name: i18n.t("serviceTypes.1") },
            { service_type: 7, name: i18n.t("serviceTypes.7") },
            { service_type: 8, name: i18n.t("serviceTypes.8") },
          ],

    innOgrn: "",
    getCompanyByInnOgrnMessage: null,
    isGetCompanyByInnOgrn: false,
    isOpenGetCompanyByInnOgrn: null,
    creditDateFrom: false,
    credit_date_from: "",
    creditDateTo: false,
    credit_date_to: "",
    rules,
    isContractKikNumber: false,
    isCommercial: false,
    validForm: false,
    setDaDataForm: null,
    isShowCompanySearch: true,
  }),
  methods: {
    getServiceBySelected() {
      if (!this.selectedProductType) return {};

      let selected = this.selectedProductType.replace("service_", "");
      if (!selected) return {};

      let foundedService = {};
      for (let p in this.serviceTypes) {
        if (this.serviceTypes[p].service_type == selected) {
          foundedService = this.serviceTypes[p];
          break;
        }
      }

      return foundedService;
    },
    onCreateNewClient() {
      this.$router.push({ name: "add-client" });
    },
    onChangeCallbackCompanySearch(obj) {
      this.bid[this.bidServiceType].customer = "";
      //this.bid[this.bidServiceType].customer_address = "";
      this.bid[this.bidServiceType].customer_inn = "";
      if (obj) {
        console.log("OK", obj.value);
        this.bid[this.bidServiceType].customer = obj.value;
        this.bid[this.bidServiceType].customer_inn = obj.inn;
        this.bid[this.bidServiceType].customer_address = obj.address.value;
      }
      console.log("onChangeCallbackCompanySearch", obj, this.bidServiceType);
    },
    setProductType(id) {
      console.log("setProductType", id);
      this.isNewTenderCreate = false;
      this.isNewTenderAllow = false;
      this.isShowSearch = true;
      this.selectedProductType = `service_${id}`;
      if (id == -1) {
        this.selectedProductType = null;
        return;
      }
      if (!id !== 1) {
        this.isCommercial = false;
      }

      if (id === 5 || id === 7) {
        this.bidServiceType = "bankKik";
        this.bid.bankKik = {};
        if (id === 7) {
          this.newTenderCreate();
          this.setDaDataForm = { inn: new String(this.client.inn) };
          this.inn = this.client.inn;
          this.bid[this.bidServiceType].tender_number = "0";
          // this.$nextTick(() => {
          //   this.bid[this.bidServiceType].customer_inn = this.client.inn;
          //   console.log("CUSTOMER INN", this.bid[this.bidServiceType].customer_inn);
          // });
        }
      } else {
        this.setDaDataForm = null;
        this.bidServiceType = "bankGuarantee";
        this.isNewTenderAllow = id === 1 ? true : false;
        this.bid.bankGuarantee = {};
        this.bid[this.bidServiceType].tender_number = null;

        if (id === 8) {
          this.setDaDataForm = { inn: new String(this.client.inn) };
          this.isNewTenderAllow = true;
          this.isNewTenderCreate = true;
          this.isShowSearch = false;
        }
      }
      this.bid.type = id;
    },
    isDisabledFindButton() {
      if (!this.bid[this.bidServiceType].tender_number) return true;
      if (
        new String(this.bid[this.bidServiceType].tender_number).trim().length ==
        0
      )
        return true;
      if (this.isCommercial) return true;
      return false;
    },
    async getTender() {
      if (this.isDisabledFindButton()) {
        showNotify("error", i18n.t("pageBids.new.emptyFieldAlert"));
        return;
      }

      this.tender = null;
      this.isLoaded = false;
      this.isProcess = true;
      this.errors = null;
      this.isNewTenderAllow = false;
      this.isNewTenderCreate = true;
      this.isShowCompanySearch = false;
      this.bid[this.bidServiceType].tender_number = this.bid[
        this.bidServiceType
      ].tender_number.trim();

      let params = {};
      if (this.bidServiceType == "bankKik") {
        params.is_contract_kik = this.isContractKikNumber ? 1 : 0;
      }
      const { type } = this.bid;
      await apiCallTrue({
        url: `v1/bids/tender/${
          this.bid[this.bidServiceType].tender_number
        }?type=${type}`,
        params,
      })
        .then((response) => {
          this.tender = response.data.data;
          this.isLoaded = true;
          this.isProcess = false;
          this.fillTenderData();
          this.isShowCompanySearch = true;
        })
        .catch((error) => {
          this.errors = error.message;
          this.isProcess = false;
          if (this.bid.type !== 5) {
            this.isNewTenderAllow = true;
          }
        });
    },
    createBid(checkValidateForm) {
      if (checkValidateForm === true && this.$refs.form) {
        if (!this.$refs.form.validate()) return;
      }

      let data = Object.assign({}, this.bid);
      data.user_id = this.userId;
      data.is_commercial = this.isCommercial;

      let params = null;
      if (this.inn) {
        params = { inn: this.inn };
      } else if (this.client && this.userRole === 30) {
        params = { inn: this.client.inn };
      }
      this.loadingCreateBid = true;
      apiCallTrue({
        url: "v1/bids",
        method: "POST",
        data,
        params,
      })
        .then((response) => {
          localStorage.removeItem("client_inn");
          this.$router.push({
            name: "ShowBid", //"confirmBid",
            params: { id: response.data.data.id },
          });
        })
        .catch((error) => {
          this.loadingCreateBid = false;
          if (error.message) {
            this.createErrors = error.message;
          }
          if (error.validation) {
            this.validationErrors = error.validation;
          }
        });
    },
    fillTenderData() {
      console.log("fillTenderData");
      this.setDaDataForm = { inn: this.tender.customer_inn };
      //console.log("SET", this.tender);
      this.bid[this.bidServiceType].security_sum = this.tender.security_amount;
      this.bid[this.bidServiceType].tender_subject = this.tender.subject;
      this.bid[this.bidServiceType].federal_law = this.tender.fz;
      this.bid[
        this.bidServiceType
      ].placement_method = this.tender.placement_method;
      this.bid[this.bidServiceType].currency = 1; // rubles
      this.bid[this.bidServiceType].lot_number = 1;
      this.bid[this.bidServiceType].customer = this.tender.customer;
      this.bid[this.bidServiceType].customer_region = this.tender.region;
      this.bid[this.bidServiceType].customer_inn = this.tender.customer_inn;
      this.bid[
        this.bidServiceType
      ].customer_address = this.tender.customer_address;
      this.bid[
        this.bidServiceType
      ].issue_deadline_date = this.tender.issue_deadline_date;
      if (this.tender.fz === 44) {
        this.bid[
          this.bidServiceType
        ].initial_contract_sum = this.tender.initial_max_cost;
        this.bid[
          this.bidServiceType
        ].actual_contract_sum = this.tender.initial_max_cost;
        this.bid[
          this.bidServiceType
        ].customer_address = this.tender.customer_address;
        this.bid[
          this.bidServiceType
        ].customer_date_registration = this.tender.customer_date_registration;
        this.bid[this.bidServiceType].customer_inn = this.tender.customer_inn;
        this.bid[
          this.bidServiceType
        ].customer_short_name = this.tender.customer_short_name;
      }
      if (this.tender.fz === 223) {
        this.bid[
          this.bidServiceType
        ].initial_contract_sum = this.tender.lots[0].initial_max_cost;
        this.bid[
          this.bidServiceType
        ].actual_contract_sum = this.tender.initial_max_cost;
      }
    },
    newTenderCreate() {
      this.tender = {};
      this.bid[this.bidServiceType].federal_law = 44;
      this.bid[this.bidServiceType].placement_method = i18n.t(
        "pageBids.new.placementMethod"
      );
      this.bid[this.bidServiceType].currency = 1; // rubles
      this.bid[this.bidServiceType].lot_number = 1;
      this.bid[this.bidServiceType].tender_number = "";
      this.bid[this.bidServiceType].actual_contract_sum = "";
      this.bid[this.bidServiceType].customer = "";
      this.bid[this.bidServiceType].customer_address = "";
      this.bid[this.bidServiceType].customer_date_registration = "";
      this.bid[this.bidServiceType].customer_inn = "";
      this.bid[this.bidServiceType].customer_region = "";
      this.bid[this.bidServiceType].customer_short_name = "";
      this.bid[this.bidServiceType].initial_contract_sum = "";
      this.bid[this.bidServiceType].security_sum = "";
      this.bid[this.bidServiceType].tender_subject = "";

      this.errors = null;
      this.isShowSearch = false;
      this.isNewTenderAllow = false;
      this.isNewTenderCreate = true;
    },
    async getCompanyByInnOgrn() {
      this.isGetCompanyByInnOgrn = true;

      await apiCallTrue({
        url: `v1/autocomplete/organization/${this.innOgrn}`,
      })
        .then((response) => {
          this.bid[this.bidServiceType].customer =
            response.data.data.data.name.full_with_opf;
          this.bid[this.bidServiceType].customer_address =
            response.data.data.data.address.value;
          this.bid[this.bidServiceType].customer_inn =
            response.data.data.data.inn;
          this.isGetCompanyByInnOgrn = false;
          this.isOpenGetCompanyByInnOgrn = null;
        })
        .catch((error) => {
          this.getCompanyByInnOgrnMessage = error.message;
          this.isGetCompanyByInnOgrn = false;
        });
    },
    getClients() {
      if ([30, 35, 100].indexOf(this.userRole) === -1) {
        this.isLoaded = true;
        return;
      }
      // if (this.userRole !== 30) return;
      apiCallTrue({
        url: "v1/agent/clients",
      })
        .then((response) => {
          if (response.data.result) {
            this.clients = response.data.data ? response.data.data : [];
            this.isLoaded = true;
          }
        })
        .catch((error) => console.error(error, "get info error"));
    },
    saveCreditDateFrom(date) {
      this.$refs.credit_date_from.save(date);
      this.deFormatCreditDateFrom();
    },
    formatCreditDateFrom() {
      if (this.credit_date_from) {
        this.bid[this.bidServiceType].credit_date_from = this.credit_date_from
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatCreditDateFrom() {
      if (this.bid[this.bidServiceType].credit_date_from) {
        const clearDate = this.bid[this.bidServiceType].credit_date_from.substr(
          0,
          10
        );
        this.credit_date_from = clearDate
          .split("-")
          .reverse()
          .join(".");
      }
    },
    saveCreditDateTo(date) {
      this.$refs.credit_date_to.save(date);
      this.deFormatCreditDateTo();
    },
    formatCreditDateTo() {
      if (this.credit_date_to) {
        this.bid[this.bidServiceType].credit_date_to = this.credit_date_to
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatCreditDateTo() {
      if (this.bid[this.bidServiceType].credit_date_to) {
        const clearDate = this.bid[this.bidServiceType].credit_date_to.substr(
          0,
          10
        );
        this.credit_date_to = clearDate
          .split("-")
          .reverse()
          .join(".");
      }
    },
  },
  computed: {
    nameClientField() {
      if (this.bid && this.bid.type == 8)
        return i18n.t("pageBids.new.nameClient.8");
      return i18n.t("pageBids.new.nameClient.default");
    },
    nameClientAddressField() {
      if (this.bid && this.bid.type == 8)
        return i18n.t("pageBids.new.addressClient.8");
      return i18n.t("pageBids.new.addressClient.default");
    },
    maxCreaditDateFrom() {
      moment.locale(i18n.locale);
      if (this.bid[this.bidServiceType].credit_date_to)
        return this.bid[this.bidServiceType].credit_date_to;
      return moment()
        .add(5, "Y")
        .format("YYYY-MM-DD");
    },
    maxCreaditDateTo() {
      moment.locale(i18n.locale);
      return moment()
        .add(5, "Y")
        .format("YYYY-MM-DD");
    },
    minCreaditDateTo() {
      moment.locale(i18n.locale);
      if (this.bid[this.bidServiceType].credit_date_from)
        return this.bid[this.bidServiceType].credit_date_from;
      return moment().format("YYYY-MM-DD");
    },
    isNewTenderValid() {
      return true;
      // console.log("CCCCC", this.bidServiceType,  this.bid[this.bidServiceType].customer_inn);
      // if(!this.bid[this.bidServiceType].customer_inn)
      //return false;
      //return true;
      //if (!this.isNewTenderCreate) return true;
      //   if (
      //       this.bid[this.bidServiceType].customer &&
      //       this.bid[this.bidServiceType].customer_address &&
      //       this.bid[this.bidServiceType].tender_subject &&
      //       this.bid[this.bidServiceType].initial_contract_sum &&
      //       this.bid[this.bidServiceType].security_sum
      //   ) {
      //       return true;
      //   } else {
      //       return false;
      //   }
    },
    ...mapState({
      userId: (state) => state.user.profile.id,
      userRole: (state) => state.user.profile.role,
      profile: (state) => state.user.profile,
    }),
  },
  watch: {
    creditDateFrom(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    creditDateTo(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },

    isCommercial(val) {
      if (val) {
        this.newTenderCreate();
      } else {
        this.isShowSearch = true;
        this.isNewTenderAllow = true;
        this.isNewTenderCreate = false;
      }
      console.log("isCommercial", val);
    },
  },
  mounted() {
    this.bid = new BidModel();
    if (this.$route.params && this.$route.params.client) {
      this.client = this.$route.params.client;
    }
    // this.$nextTick(() => {
    //     this.getClients();
    // });
    setTimeout(() => this.getClients(), 500);

    this.inn = localStorage.getItem("client_inn") || null;
  },
};
</script>
<style lang="scss">
table.service-list-table {
  width: auto;
  margin: 0 auto;
}
.service {
  &__item {
    margin: 0;
    color: #aaa;
    cursor: pointer;

    & + .service__item {
      margin-left: 60px;
    }

    &.active {
      color: #404ce6;

      .service__icon svg path {
        fill: #404ce6;
      }
    }
    h2 {
      text-align: center;
      &.left {
        text-align: left;
      }
    }
  }
  &__icon {
    max-width: 50px;
    max-height: 50px;
    margin: 0 auto;

    svg {
      display: block;
      width: 100%;
      height: 100%;

      path {
        fill: #aaa;
      }
    }
  }
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.bid {
  &__create {
    text-align: center;
    padding: 40px 0 !important;

    &-blank {
      color: #404ce6;
      // font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
    }

    &-tender {
      // margin-top: 40px !important;

      // &::before {
      //     content: "";
      //     display: block;
      //     width: calc(100% - 60px);
      //     height: 1px;
      //     background: #dadada;
      //     margin: 0 auto 40px;
      // }
      > &-number {
        min-width: 220px;
      }
    }
  }
  &__tender-content {
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 0 20px #eee;
    background: #fff;
    max-width: 700px;
    margin: 0 auto !important;
    display: block;
  }

  &__tender {
    &-title {
      // font-style: italic;
      font-weight: 600;
    }
    &-content {
      .v-expansion-panel {
        box-shadow: 0 0 0;

        &__header {
          padding: 0 16px !important;
          background: #f0f0f0;
        }
      }
    }
  }
}
</style>
